interface TokenConfiguration {
    pattern?: RegExp
    escape?: boolean
    repeat?: boolean
    uppercase?: boolean
    lowercase?: boolean
}

const TOKENS: Record<string, TokenConfiguration> = {
    '#': {pattern: /[0-9]/},
    'X': {pattern: /[0-9a-zA-Z]/},
    'S': {pattern: /[a-zA-Z]/},
    'A': {pattern: /[a-zA-Z]/, uppercase: true},
    'a': {pattern: /[a-zA-Z]/, lowercase: true},
    '!': {escape: true},
    '*': {repeat: true}
};

export function getRegexFromMask(mask: string): RegExp {

    let regex: string[] = [], maskChar: string, token: undefined | TokenConfiguration;

    for (let i = 0; i < mask.length; i++) {

        maskChar = mask[i];
        token = TOKENS[maskChar];

        if (token) {

            if (token.escape) {

                regex.push("\\");
            }

            if (token.repeat) {

                regex.push("+");
            }

            if (token.pattern) {

                regex.push(token.pattern.source);
            }
        } else {

            regex.push("\\" + maskChar);
        }
    }

    return new RegExp(["^", regex.join(""), "$"].join(""));
}

/* eslint quote-props: ["error", "consistent"] */
export default TOKENS;